import { memo } from "react";
import { useSceneData } from "~/common/stores/useSceneData";
import { UISystemSetup } from "./UISystemSetup";

export const UISystem = memo(() => {
  const uiEnabled = useSceneData((state) => state.sceneState?.uiSystem?.enabled ?? true);

  return uiEnabled ? <UISystemSetup /> : null;
});
